/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const LtiRoleSwitchingSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('LTI_ROLE_SWITCHING')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class LtiRoleSwitchingSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return LtiRoleSwitchingSettingParser.decode(input).map(res => new LtiRoleSwitchingSetting(res));
    }
    static unsafeDecode(input) {
        return LtiRoleSwitchingSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return LtiRoleSwitchingSettingParser.encode(data);
    }
    static schema() {
        return LtiRoleSwitchingSettingParser.schema();
    }
}
